'use client';

import classNames from '@sindresorhus/class-names';
import {SelectItem, SelectModal} from '@ui-kit/src/SelectModal/SelectModal';
import Link from 'next/link';
import {usePathname, useRouter} from 'next/navigation';
import {useState} from 'react';

import {useFilters} from '@web-catalog/hooks/useFilters';

import {logTmrEvent} from '@web-catalog/utils/analytics';

import styles from './Filters.module.scss';

const filterVariants = {
  free: {
    value: 'free',
    text: 'Бесплатные',
  },
  paid: {
    value: 'paid',
    text: 'Платные',
  },
};

const sortVariants = [
  {
    title: 'По популярности',
    description: 'Сначала самые скачиваемые',
    value: 'popular',
  },
  {
    title: 'По рейтингу',
    description: 'Сначала с высоким рейтингом',
    value: 'rating',
  },
];

const PAGINATION_REGEXP = new RegExp('/page-\\d+', 'g');

export const Filters = () => {
  const router = useRouter();
  const pathName = usePathname();
  const [isOpened, setOpened] = useState(false);
  const {filterBy, sortBy, getFullValue} = useFilters();

  const onFilterClick = (event: React.MouseEvent, value: string) => {
    logTmrEvent({
      logEvent: 'filter.select',
      params: {
        filter: value,
      },
    });
    if (value === filterBy.get()) {
      event.preventDefault();
      filterBy.set(null);
      router.push(pathName.replace(PAGINATION_REGEXP, '') + getFullValue());
    }
  };

  const onSelect = (item: SelectItem<string>) => {
    logTmrEvent({logEvent: 'sortBy.select', params: {sort_by: item.value}});
    sortBy.set(item.value);
    router.push(pathName.replace(PAGINATION_REGEXP, '') + getFullValue());
  };

  const currentValue = sortVariants.find((item) => item.value === sortBy.get());

  return (
    <div
      className={classNames(styles.filters, {
        [styles.filters__isOpened]: isOpened,
      })}
    >
      <SelectModal
        values={sortVariants}
        defaultValue={sortVariants[0]}
        currentValue={currentValue}
        onSelect={(item) => onSelect(item)}
        dataTestIdPrefix="sort"
        onOpen={(state) => setOpened(state)}
      />
      {Object.values(filterVariants).map((item) => (
        <Link
          className={classNames(styles.filter, {
            [styles.filter__active]: filterBy.get() === item.value,
          })}
          href={`${pathName.replace(PAGINATION_REGEXP, '')}?filterBy=${item.value}${sortBy.get() ? '&sortBy=' + sortBy.get() : ''}`}
          onClick={(event) => onFilterClick(event, item.value)}
          key={item.value}
          data-testid={`filterButton-${item.value}`}
          data-state={filterBy.get() === item.value ? 'active' : 'unactive'}
        >
          {item.text}
        </Link>
      ))}
    </div>
  );
};
